export const languageElements = {
  items: {
    "header-title-greeting": {
      hu: "ÜGYFÉLKAPU",
      de: "CUSTOMER PORTAL",
      en: "CUSTOMER PORTAL",
    },

    "header-title-dismissRegistration": {
      hu: "LEIRATKOZÁS",
      de: "ABMELDUNG",
      en: "UNSUBSCRIBE",
    },

    "header-title-firstLogin": {
      hu: "Első belépés",
      de: "Erste Anmeldung",
      en: "First login",
    },

    "header-title-login": {
      hu: "ÜGYFÉLKAPU - Belépés",
      de: "CUSTOMER PORTAL - Login",
      en: "CUSTOMER PORTAL - Login",
    },

    "header-title-home": {
      hu: "Hírek, üzenetek",
      de: "Infos und Meldungen",
      en: "News and Messages",
    },

    "header-title-invoices": {
      hu: "Számláim",
      de: "Abrechnungen",
      en: "Invoices",
    },

    "header-title-stocks": {
      hu: "Raktárkészletem",
      de: "Warenbestände",
      en: "Stocks of goods",
    },

    "header-title-tracking": {
      hu: "Fuvarjaim",
      de: "Frächte",
      en: "Freight",
    },

    "header-title-tracking-system": {
      hu: "Áru nyomkövetés",
      de: "Tracking system",
      en: "Tracking system",
    },

    "header-title-settings": {
      hu: "Beállítások",
      de: "Einstellungen",
      en: "Settings",
    },

    "header-title-contact": {
      hu: "Kapcsolat",
      de: "Kontakt",
      en: "Contact",
    },
  },
};
